
import React, { ReactElement } from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";

interface FormFieldWrapperProps {
  form: UseFormReturn<any>;
  name: string;
  label: string;
  placeholder: string;
  required?: boolean;
  children: ReactElement;
}

const FormFieldWrapper: React.FC<FormFieldWrapperProps> = ({ 
  form, 
  name, 
  label, 
  placeholder, 
  required = false,
  children 
}) => {
  // Clone the child element with additional props
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-gray-200">
            {label} {required && '*'}
          </FormLabel>
          <FormControl>
            {React.cloneElement(children, { 
              ...field,
              ...(placeholder ? { placeholder } : {}),
              className: `neo-input${children.props.className ? ` ${children.props.className}` : ""}` 
            })}
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default FormFieldWrapper;
